export const POPULAR_PROJECT_CATEGORY_ID = "f1a2b3c4-d5e6-4f7a-8b9c-0d1e2f3a4b5c";
export const AMAZON_SHOP_ID = "2d0d4809-e6bd-36f4-9b3e-547f27b1873c";
